import Phaser from "phaser";
import { LeaderboardEntry } from "../systems/LeaderboardService";

export class LeaderboardPanel {
    private readonly scene: Phaser.Scene;
    private readonly container: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number) {
        this.scene = scene;

        const bg = scene.add.rectangle(0, 0, width, height, 0x16324d, 0.88).setStrokeStyle(3, 0x9fd5ff, 0.5);
        const title = scene.add
            .text(0, -height / 2 + 32, "Leaderboard", {
                fontSize: "34px",
                color: "#ffffff",
            })
            .setOrigin(0.5, 0.5);

        this.container = scene.add.container(x, y, [bg, title]).setDepth(50);
    }

    render(entries: LeaderboardEntry[]): void {
        this.container.removeAll(true);

        const width = 640;
        const height = 520;
        const bg = this.scene.add.rectangle(0, 0, width, height, 0x16324d, 0.88).setStrokeStyle(3, 0x9fd5ff, 0.5);
        const title = this.scene.add
            .text(0, -height / 2 + 32, "Leaderboard", {
                fontSize: "34px",
                color: "#ffffff",
            })
            .setOrigin(0.5, 0.5);

        this.container.add([bg, title]);

        if (entries.length === 0) {
            const empty = this.scene.add
                .text(0, 14, "No scores yet", {
                    fontSize: "28px",
                    color: "#cde8ff",
                })
                .setOrigin(0.5, 0.5);
            this.container.add(empty);
            return;
        }

        entries.forEach((entry, index) => {
            const y = -height / 2 + 86 + index * 38;
            const row = this.scene.add
                .text(-width / 2 + 28, y, `${index + 1}. ${entry.initials}  ${entry.score}  ${entry.lakeName}`, {
                    fontSize: "24px",
                    color: index < 3 ? "#ffe7a6" : "#d8ecff",
                })
                .setOrigin(0, 0.5);
            this.container.add(row);
        });
    }

    setVisible(isVisible: boolean): void {
        this.container.setVisible(isVisible);
    }
}
